module.exports = __webpack_public_path__ + "img/gwinnett-campus.7249336f.jpg";